// extracted by mini-css-extract-plugin
export default {"quick_links_container":"index-modules__quick_links_container--PmpNb","quick_link":"index-modules__quick_link--iCJVH","quick_link__grow":"index-modules__quick_link__grow--EfZK2"};